import(/* webpackMode: "eager" */ "/opt/build/repo/app/synoptique/page.tsx");
